export default __webpack_public_path__ + "static/media/table.4bba1c73.png";